/** Mirror of `socaity_schemas.platform.organization`. */

export class Organization {
  id: string | null;
  name: string;
  url: string | null;
  logo_url: string | null;

  constructor(data: Record<string, any> = {}) {
    this.id = data.id ?? null;
    this.name = data.name ?? '';
    this.url = data.url ?? null;
    this.logo_url = data.logo_url ?? null;
  }
}

export class ScoreSource {
  id: string | null;
  name: string;
  url: string | null;
  logo_url: string | null;

  constructor(data: Record<string, any> = {}) {
    this.id = data.id ?? null;
    this.name = data.name ?? '';
    this.url = data.url ?? null;
    this.logo_url = data.logo_url ?? null;
  }
}
